import { connect } from 'react-redux'
import heartbeatsProviderSelector from './heartbeatsProviderSelector'
import {
  remove as removeHeartbeat,
} from 'store/redux/heartbeats'
import HeartbeatsProvider from './HeartbeatsProvider'

export default connect(
  heartbeatsProviderSelector,
  {
    removeHeartbeat
  }
)(HeartbeatsProvider)
